export default "__VITE_ASSET__7afpPHl5__"